export enum PageType {
	NEW = "NEW",
	EDIT = "EDIT"
}
